<div class="day-use-rooms-content" [style.margin-bottom.px]="footerEle()?.nativeElement?.offsetHeight">
  @if (isCalendarSidepanel()) {
    <app-toggle
      [toggleId]="dayUseRoomsToggle().id"
      [label]="dayUseRoomsToggle().label"
      [isChecked]="dayUseRoomsToggle().selected"
      (isChanged)="onDayUseRoomsToggleSelectionChanged($event)"
    />
  } @else {
    <app-checkbox [data]="[dayUseRoomsToggle()]" cname="day-use-rooms"
      (selectionChanged)="onDayUseRoomsSelectionChanged($event)"
    />
  }
</div>

@if(isSidePanel()) {
  <div class="actions-container" #footer
    [class.fixed-bottom]="isSidePanel()"
    [class.s-px-32]="isSidePanel() && !isMobileLarge()"
    [class.s-px-20]="isSidePanel() && isMobileLarge()"
    [class.s-py-32]="isSidePanel() && !isMobileLarge()"
    [class.s-py-20]="isSidePanel() && isMobileLarge()"
    [class.neutral-white-color-bg]="isSidePanel()"
  >
    <app-button-group
      [classes]="'d-flex justify-content-end'"
      [options]="btnGroupOptions()"
      (onClickEvent)="handleAction($event)"
    />
  </div>
}